import gql from 'graphql-tag';

import client from '../graphqlAPI';

const GET_EVENTS_LIST = gql`
query getEventsList ($search: String, $limit: Int, $offset: Int, $sortField: String, $sortOrder: Int){
    getEventsList(search: $search, limit: $limit, offset: $offset, sortField: $sortField, sortOrder: $sortOrder) {
      total
      isAuth
      ticketSlugNames
      venueSlugNames
      eventSlugNames
      events {
        _id
        artistSets
        beginDateTime
        createdAt
        description {
          en
          es
          ca
          pt
        }
        endDateTime
        eventsArray
        eventName
        eventReadableName {
          en
          es
          ca
          pt
        }
        subtitle {
          en
          es
          ca
          pt
        }
        pretitle {
          en
          es
          ca
          pt
        }
        eventSlugName
        image {
          en
          es
          ca
          pt
        }
        updatedAt
        postSlugNames
        tickets
        totalCapacity
        salePostSlugName
        venues
        showDate
        showDateTime
        showTicket
        showVenue
        genres
        timezone
        mentors
      }
    }
  }
`;

const getEventsList = async (search = '', { limit, offset, sortField, sortOrder } = {}) => {
  try {
    const result = await client
      .query({
        query: GET_EVENTS_LIST,
        errorPolicy: 'all',
        fetchResults: true,
        fetchPolicy: 'no-cache',
        variables: { search, limit, offset, sortField, sortOrder },
      })
      .then(queryResult => queryResult)
      .catch((queryError) => {
        console.log('\x1b[31m%s\x1b[0m', `${new Date().toLocaleTimeString()} ~ Client: Apollo Client Query Error: ${queryError}`);
        return null;
      });

    const {
      data: { getEventsList: eventsListData },
    } = result;

    if (eventsListData) {
      return eventsListData;
    }
    console.log('\x1b[31m%s\x1b[0m', `${new Date().toLocaleTimeString()} ~ Client: GraphQL Query Error: getEventsList = null`);
    return null;
  } catch (error) {
    console.log('\x1b[31m%s\x1b[0m', `${new Date().toLocaleTimeString()} ~ Client: getEventsList Error: ${error}`);
    return null;
  }
};

export default getEventsList;
